'use strict';

angular.module('TurneroApp').component('coHeaderLlamador', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        '$interval',
        function ($interval) {
            var ctrl = this;

            var tick = function () {
                ctrl.clock = Date.now();
            }
            tick();
            $interval(tick, 1000);

        }],
    template: require('./headerLlamador.html')
});


// WEBPACK FOOTER //
// ./app/shared/header/headerLlamadorComponent.js